import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";

export function Component() {
  const error = useRouteError();

  useEffect(() => {
    if (!isRouteErrorResponse(error)) {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-ecru px-6 py-12 text-center">
      <div className="max-w-xl space-y-4">
        <h1 className="text-3xl font-semibold text-midnight">Something went wrong</h1>
        <p className="text-midnight/70">An unexpected error occurred. Please try refreshing the page.</p>
        <button
          onClick={() => (window.location.href = "/")}
          className="mx-auto mt-2 block rounded-lg bg-midnight px-6 py-3 text-base font-medium text-white transition hover:bg-midnight/80">
          Refresh page
        </button>
      </div>
    </div>
  );
}
